import { TableCard } from '../../../../components'
import { ClienteHeading } from '../empresasCliente-list/components/ClienteHeading'
import { RiscoClienteListHeader } from './components/header/RiscoClienteListHeader'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { RiscoClienteTable } from './table/RiscoClienteTable'

const RiscoClienteList = () => {
  return (
    <>
      <ClienteHeading />
      <TableCard>
        <RiscoClienteListHeader />
        <RiscoClienteTable />
      </TableCard>
    </>
  )
}

export const RiscoClienteListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <RiscoClienteList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
